import XLSX from "xlsx";
import { timeFormat, timeParse } from "d3";
import moment from "moment";
import { formatDate_YMD_AddDays } from "@/_core/_helpers/_helpers.js";
import { Holidays } from "@/_core/_helpers/holidays/Holidays";

export const SheetsTransaction = function(_Data = null, _Headers = null) {
  this._Data = _Data;
  this._Headers = _Headers;
  this.transformed_data = null;
  this.holidays = null;
};

SheetsTransaction.prototype.checkIfDate = function(_Object) {
  if (Object.keys(_Object).indexOf("date") !== -1) {
    this.holidays = new Holidays(_Object.date);
  }
};

SheetsTransaction.prototype.import = function(_Indexes, someAds) {
  this.checkIfDate(someAds);
  const workbook = XLSX.read(this._Data, {
    type: "binary" // binary
  });
  const wsname = workbook.SheetNames[0]; //take the first sheet
  const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //Get the data in this table
  const context = this;
  ws.forEach(value => {
    let keys = Object.keys(value);
    let object_asssigned = {};
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase().includes("date")) {
        object_asssigned[_Indexes[i]] = this.estimateDate(value[keys[i]]);
      } else {
        object_asssigned[_Indexes[i]] = value[keys[i]];
      }
    }
    context._Headers.push(object_asssigned);
  });
};

SheetsTransaction.prototype.estimateDate = function(_Days) {
  return this.holidays.searchAvailableDate(
    formatDate_YMD_AddDays("1899/12/30", _Days)
  );
};

SheetsTransaction.prototype.export = function(_list_to_filename) {
  this.transform_data();
  let data = XLSX.utils.json_to_sheet(this.transformed_data);
  let keys, idx;
  for (const key in data) {
    keys = Object.keys(data[key]);
    idx = keys.indexOf("z");
    if (idx > -1 && data[key].z === "m/d/yy") {
      data[key].v = Math.round(data[key].v);
    }
  }
  const workbook = XLSX.utils.book_new();
  const filename = this.set_title(_list_to_filename);
  XLSX.utils.book_append_sheet(workbook, data, filename);
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

SheetsTransaction.prototype.set_title = function(_list_to_filename) {
  let filename = "";
  var formatTime = timeFormat("%Y-%m-%d");
  _list_to_filename.forEach(name => {
    filename += name;
    filename += "_";
  });
  return filename + formatTime(new Date());
};

SheetsTransaction.prototype.set_data = function(_Data) {
  this._Data = _Data;
};

SheetsTransaction.prototype.set_headers = function(_Headers) {
  delete _Headers[0];
  this._Headers = _Headers;
};

SheetsTransaction.prototype.transform_data = function() {
  this.transformed_data = this._Data.map(d => this.get_object(d));
};

SheetsTransaction.prototype.get_object = function(d) {
  let object_assigned = {};
  this._Headers.forEach(header_obj => {
    object_assigned[header_obj.text] = d[header_obj.value];
  });
  return object_assigned;
};

SheetsTransaction.prototype.getFormat = function(d) {
  var dateFormats = {
    iso_int: "YYYY-MM-DD",
    short_date: "DD/MM/YYYY",
    iso_date_time: "YYYY-MM-DDTHH:MM:SS",
    iso_date_time_utc: "YYYY-MM-DDTHH:MM:SSZ"
  };
  for (var prop in dateFormats) {
    if (moment(d, dateFormats[prop], true).isValid()) {
      return timeParse("%Y-%m-%d")(d);
    }
  }
  return d;
};

SheetsTransaction.prototype.formatting_data = function(_Values) {
  _Values.forEach(element => {
    for (const property in element) {
      element[property] = this.getFormat(element[property]);
    }
  });
};
